export default __webpack_public_path__ + "static/media/takeoff.7b1165f0.svg";